<script>
import { bApp, isWeCom, isMiniBankInsurance } from 'base/config'
import { APP_CHANNEL, isBaoXiaoZhuSingle, isBaoXiaoZhuPlatform } from 'common/utils/variables'
import { mapState } from 'vuex'
import popupOpen from './popupOpen.vue'

export default {
  components: {
    popupOpen
  },
  props: {
    isGaokeAgent: Boolean,
    isPolicyCheck: Boolean,
    isSchemeShow: Boolean,
    isTrade: Boolean,
    isShowThemePicker: Boolean,
    isJumpToCompare3:Number
  },
  data () {
    this.bApp = bApp
    this.isWeCom = isWeCom
    this.isMiniBankInsurance = isMiniBankInsurance
    return {
      isShowPopupOpen: false,
      jumpSource: null,
      isBaoXiaoZhuSingle,
      isBaoXiaoZhuPlatform
    }
  },
  computed: {
    ...mapState(['userInfo']),
    isShowGenerateImageButton () {
      return !isWeCom
    },
    isShowInsuredButton () {
      return bApp && this.isTrade
    },
    isShowShareButton () {
      return !this.isTrade && (bApp || ['WECHAT_GAOKE', 'WXMP', 'WXMP_BXZ', 'BaoXiaoZhu'].includes(APP_CHANNEL))
    }
  },
  watch:{
    isJumpToCompare3:{
      immediate:true,
      deep:true,
      handler(val){
        this.jumpSource = val
      }
    }
  },
  methods: {
    handleClick (typeName) {
      this.$emit('invoke', typeName)
    },
    handlePopupClick(typeName) {
      this.closePopup()
      this.$emit('invoke', typeName)
    },
    closePopup() {
      this.isShowPopupOpen = false
    },
    handleOutsideClick(event) {
      if (this.isShowPopupOpen) {
        const popupElement = this.$el.querySelector('.popup-open')
        const moreButton = this.$el.querySelector('.more')
        if (popupElement && !popupElement.contains(event.target) &&
            moreButton && !moreButton.contains(event.target)) {
          this.closePopup()
        }
      }
    }
  }
}
</script>
<template>
  <div class="base-layer">
    <template v-if="isPolicyCheck">
      <a
        class="btn save primary"
        href="javascript:;"
        @click="handleClick('save')"
      >保存</a>
      <a
        v-if="!isWeCom && !isMiniBankInsurance && !isGaokeAgent"
        class="btn generate"
        href="javascript:;"
        @click="handleClick('generate-image')"
      >导出图片</a>
      <a
        class="btn share"
        data-stat-id="share_bottom"
        @click="handleClick('share')"
      >分享</a>
    </template>
    <template v-else>
      <span
        v-if="jumpSource === 1 && !['H5_BXZ'].includes(APP_CHANNEL)"
        class="more"
        :class="{
          more_active: isShowPopupOpen === true
        }"
        data-stat-id="bottom_bar_more"
        @click="isShowPopupOpen=!isShowPopupOpen"
      >
        <i class="iconfont icon-style_line" />
        {{ isShowPopupOpen===false?'更多':'收起' }}
      </span>
      <a
        v-if="isShowThemePicker && jumpSource !== 1 || ['H5_BXZ'].includes(APP_CHANNEL)"
        class="btn theme-picker"
        href="javascript:;"
        data-stat-id="theme_picker_bottom"
        @click="handleClick('openThemePicker')"
      >换肤</a>
      <a
        class="btn generate"
        href="javascript:;"
        data-stat-id="wendang"
        @click="handleClick('generate')"
      >导出文档</a>
      <a
        v-if="isShowGenerateImageButton"
        class="btn generate"
        href="javascript:;"
        @click="handleClick('generate-image')"
      >导出图表</a>
      <a
        v-if="isSchemeShow && jumpSource !== 1"
        class="btn interpretation minor"
        href="javascript:;"
        @click="handleClick('interpretation')"
      >讲解方案</a>
      <a
        v-if="isShowInsuredButton"
        class="btn insured"
        href="javascript:;"
        @click="handleClick('insured')"
      >立即投保</a>
      <a
        v-if="jumpSource === 1 && (!isBaoXiaoZhuPlatform || (userInfo && userInfo.pbCompareFlag))"
        :class="['btn', 'interpretation', 'minor'].concat(((['BXS', 'WXMP', 'WXMP_BXZ', 'WECHAT_BXS', 'WECHAT_BXZ'].includes(APP_CHANNEL) || isBaoXiaoZhuSingle) && !['H5_BXZ'].includes(APP_CHANNEL) ? ['compare3'] : []))"
        href="javascript:;"
        @click="handleClick('compare3')"
      >利益对比</a>
      <a
        v-if="isShowShareButton"
        class="btn share primary"
        data-stat-id="share_bottom"
        @click="handleClick('share')"
      >分享</a>

      <popup-open v-if="isShowPopupOpen" @invoke="handlePopupClick" />
    </template>
  </div>
</template>
<style lang="postcss" scoped>
.base-layer {
  display: flex;
  flex: 2;
  position: relative;
  .btn {
    display: block;
    flex: 1;
    line-height: 34px;
    padding: 0px 5px;
    border-radius: 0.12rem;
    border: 1px solid #ccc;
    margin-left: 0.2rem;
    white-space: nowrap;
    &:first-child {
      margin-left: 0;
    }
  }
  .btn.compare3{
    position: relative;
    &::after{
      content: '';
      position: absolute;
      top: -6px;
      right: -10px;
      width: 16px;
      height: 16px;
      background: url('https://media.winbaoxian.com/assets-uploader/vip-tag-3-1761111241308.png') no-repeat center center;
      background-size: 100% 100%;
    }
  }
  .more{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #333333 ;
    i{
      font-size: 22px;
    }
    font-size: 10px;
  }
  .more_active{
    color: #0A64FE;

  }

  .btn:first-child:nth-last-child(n+5),
  .btn:first-child:nth-last-child(n+5) ~ .btn {
    font-size: 93%;
  }
}
</style>
